import { useTranslation } from 'react-i18next'
import { ShieldCheck, FileText } from 'lucide-react'
import { LEGAL_CS, type LegalDoc } from '../data/legalPages'
import lpEn from '../data/legalPages.en.json'
import lpDe from '../data/legalPages.de.json'
import lpPl from '../data/legalPages.pl.json'
import lpSk from '../data/legalPages.sk.json'
import lpIt from '../data/legalPages.it.json'
import lpHu from '../data/legalPages.hu.json'
import lpUk from '../data/legalPages.uk.json'
import lpEs from '../data/legalPages.es.json'
import lpFr from '../data/legalPages.fr.json'
import lpNl from '../data/legalPages.nl.json'
import lpJa from '../data/legalPages.ja.json'

const UPDATED = '7. 6. 2026'
const TRANS: Record<string, { privacy: LegalDoc; terms: LegalDoc }> = {
  en: lpEn as any, de: lpDe as any, pl: lpPl as any, sk: lpSk as any, it: lpIt as any, hu: lpHu as any, uk: lpUk as any, es: lpEs as any, fr: lpFr as any, nl: lpNl as any, ja: lpJa as any,
}

/** Vykreslí právní dokument (privacy / terms) v aktivním jazyce, čeština jako fallback. */
export default function LegalDocView({ doc }: { doc: 'privacy' | 'terms' }) {
  const { t, i18n } = useTranslation()
  const source = (TRANS[i18n.language] || (i18n.language !== 'cs' && TRANS.en) || LEGAL_CS)[doc] || LEGAL_CS[doc]
  const Icon = doc === 'privacy' ? ShieldCheck : FileText

  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <div className="inline-flex items-center gap-2 bg-primary-50 text-primary-600 px-4 py-1.5 rounded-full text-xs font-semibold mb-4">
        <Icon className="w-3.5 h-3.5" /> {source.badge}
      </div>
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">{source.title}</h1>
      <p className="text-sm text-gray-400 mb-8">{t('legal.updated')}: {UPDATED}</p>

      <div className="space-y-6 text-sm leading-relaxed text-gray-700 dark:text-gray-300">
        {source.sections.map((s, i) => (
          <section key={i}>
            <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-2">{s.h}</h2>
            <div className="legal-body" dangerouslySetInnerHTML={{ __html: s.html }} />
          </section>
        ))}
      </div>
    </div>
  )
}
